// extracted by mini-css-extract-plugin
module.exports = {"text":"text_button-module__text--T-d9O","content":"text_button-module__content--1SbPi"};